/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetAllergyModel } from './PetAllergyModel';
import {
    PetAllergyModelFromJSON,
    PetAllergyModelFromJSONTyped,
    PetAllergyModelToJSON,
} from './PetAllergyModel';
import type { PetBreedReferenceModel } from './PetBreedReferenceModel';
import {
    PetBreedReferenceModelFromJSON,
    PetBreedReferenceModelFromJSONTyped,
    PetBreedReferenceModelToJSON,
} from './PetBreedReferenceModel';
import type { PetDerivedModel } from './PetDerivedModel';
import {
    PetDerivedModelFromJSON,
    PetDerivedModelFromJSONTyped,
    PetDerivedModelToJSON,
} from './PetDerivedModel';
import type { PetMedicalConditionModel } from './PetMedicalConditionModel';
import {
    PetMedicalConditionModelFromJSON,
    PetMedicalConditionModelFromJSONTyped,
    PetMedicalConditionModelToJSON,
} from './PetMedicalConditionModel';
import type { PetMedicationAllergyModel } from './PetMedicationAllergyModel';
import {
    PetMedicationAllergyModelFromJSON,
    PetMedicationAllergyModelFromJSONTyped,
    PetMedicationAllergyModelToJSON,
} from './PetMedicationAllergyModel';
import type { PetMedicationModel } from './PetMedicationModel';
import {
    PetMedicationModelFromJSON,
    PetMedicationModelFromJSONTyped,
    PetMedicationModelToJSON,
} from './PetMedicationModel';
import type { PetPrimaryDisciplineModel } from './PetPrimaryDisciplineModel';
import {
    PetPrimaryDisciplineModelFromJSON,
    PetPrimaryDisciplineModelFromJSONTyped,
    PetPrimaryDisciplineModelToJSON,
} from './PetPrimaryDisciplineModel';
import type { PetProfileAvatarModel } from './PetProfileAvatarModel';
import {
    PetProfileAvatarModelFromJSON,
    PetProfileAvatarModelFromJSONTyped,
    PetProfileAvatarModelToJSON,
} from './PetProfileAvatarModel';
import type { PetRidingStyleModel } from './PetRidingStyleModel';
import {
    PetRidingStyleModelFromJSON,
    PetRidingStyleModelFromJSONTyped,
    PetRidingStyleModelToJSON,
} from './PetRidingStyleModel';
import type { PetTypeModel } from './PetTypeModel';
import {
    PetTypeModelFromJSON,
    PetTypeModelFromJSONTyped,
    PetTypeModelToJSON,
} from './PetTypeModel';
import type { SubmitterModel } from './SubmitterModel';
import {
    SubmitterModelFromJSON,
    SubmitterModelFromJSONTyped,
    SubmitterModelToJSON,
} from './SubmitterModel';

/**
 * 
 * @export
 * @interface PetProfileModel
 */
export interface PetProfileModel {
    /**
     * System assigned. Not modifiable during creation or update.
     * @type {number}
     * @memberof PetProfileModel
     */
    id?: number;
    /**
     * 
     * @type {SubmitterModel}
     * @memberof PetProfileModel
     */
    submitter?: SubmitterModel;
    /**
     * 
     * @type {number}
     * @memberof PetProfileModel
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof PetProfileModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PetProfileModel
     */
    ownerName?: string;
    /**
     * 
     * @type {PetTypeModel}
     * @memberof PetProfileModel
     */
    type: PetTypeModel;
    /**
     * 
     * @type {string}
     * @memberof PetProfileModel
     */
    gender?: PetProfileModelGenderEnum;
    /**
     * 
     * @type {PetDerivedModel}
     * @memberof PetProfileModel
     */
    derived?: PetDerivedModel;
    /**
     * 
     * @type {boolean}
     * @memberof PetProfileModel
     */
    sterilization?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PetProfileModel
     */
    assistanceAnimal?: boolean | null;
    /**
     * Current age in months.
     * @type {number}
     * @memberof PetProfileModel
     */
    age?: number | null;
    /**
     * System assigned. Not modifiable during creation or update.
     * @type {boolean}
     * @memberof PetProfileModel
     */
    readonly birthdayEstimated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PetProfileModel
     */
    birthday?: string | null;
    /**
     * System assigned. Not modifiable during creation or update.
     * @type {string}
     * @memberof PetProfileModel
     */
    readonly lifestage?: PetProfileModelLifestageEnum;
    /**
     * System assigned. Not modifiable during creation or update.
     * @type {boolean}
     * @memberof PetProfileModel
     */
    readonly adopted?: boolean;
    /**
     * remove adoption date on PATCH if cannot set adoption date to null
     * @type {boolean}
     * @memberof PetProfileModel
     */
    markAdoptionForDeletion?: boolean;
    /**
     * Set to null to remove on PATCH
     * @type {string}
     * @memberof PetProfileModel
     */
    adoptionDate?: string | null;
    /**
     * unique identifier to store “model Id” for a pet profile. This is not related to existing petAvatar object.
     * @type {string}
     * @memberof PetProfileModel
     */
    avatarModelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PetProfileModel
     */
    size?: PetProfileModelSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof PetProfileModel
     */
    fullGrownSize?: PetProfileModelFullGrownSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof PetProfileModel
     */
    weightType?: PetProfileModelWeightTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PetProfileModel
     */
    weight?: number | null;
    /**
     * Only modifiable during creation.
     * @type {string}
     * @memberof PetProfileModel
     */
    source?: PetProfileModelSourceEnum;
    /**
     * Only modifiable during update.
     * @type {string}
     * @memberof PetProfileModel
     */
    status?: PetProfileModelStatusEnum;
    /**
     * Only modifiable during update.
     * @type {string}
     * @memberof PetProfileModel
     */
    statusReason?: PetProfileModelStatusReasonEnum;
    /**
     * 
     * @type {Array<PetBreedReferenceModel>}
     * @memberof PetProfileModel
     */
    breeds?: Array<PetBreedReferenceModel>;
    /**
     * 
     * @type {Array<PetRidingStyleModel>}
     * @memberof PetProfileModel
     */
    ridingStyles?: Array<PetRidingStyleModel>;
    /**
     * 
     * @type {Array<PetPrimaryDisciplineModel>}
     * @memberof PetProfileModel
     */
    primaryDisciplines?: Array<PetPrimaryDisciplineModel>;
    /**
     * 
     * @type {Array<PetAllergyModel>}
     * @memberof PetProfileModel
     */
    allergies?: Array<PetAllergyModel>;
    /**
     * 
     * @type {Array<PetMedicationModel>}
     * @memberof PetProfileModel
     */
    medications?: Array<PetMedicationModel>;
    /**
     * 
     * @type {Array<PetMedicationAllergyModel>}
     * @memberof PetProfileModel
     */
    medicationAllergies?: Array<PetMedicationAllergyModel>;
    /**
     * 
     * @type {Array<PetMedicalConditionModel>}
     * @memberof PetProfileModel
     */
    medicalConditions?: Array<PetMedicalConditionModel>;
    /**
     * Set to null to remove on PATCH
     * @type {string}
     * @memberof PetProfileModel
     */
    bannerImageUri?: string | null;
    /**
     * remove banner image on PATCH if cannot set bannerImageUri to null
     * @type {boolean}
     * @memberof PetProfileModel
     */
    markBannerImageForDeletion?: boolean;
    /**
     * 
     * @type {PetProfileAvatarModel}
     * @memberof PetProfileModel
     */
    avatar?: PetProfileAvatarModel | null;
}


/**
 * @export
 */
export const PetProfileModelGenderEnum = {
    Unknown: 'UNKNOWN',
    Male: 'MALE',
    Female: 'FEMALE'
} as const;
export type PetProfileModelGenderEnum = typeof PetProfileModelGenderEnum[keyof typeof PetProfileModelGenderEnum];

/**
 * @export
 */
export const PetProfileModelLifestageEnum = {
    Unknown: 'UNKNOWN',
    Senior: 'SENIOR',
    Adult: 'ADULT',
    Puppy: 'PUPPY',
    Kitten: 'KITTEN'
} as const;
export type PetProfileModelLifestageEnum = typeof PetProfileModelLifestageEnum[keyof typeof PetProfileModelLifestageEnum];

/**
 * @export
 */
export const PetProfileModelSizeEnum = {
    Unknown: 'UNKNOWN',
    Xs: 'XS',
    Sm: 'SM',
    M: 'M',
    L: 'L',
    Xl: 'XL',
    G: 'G'
} as const;
export type PetProfileModelSizeEnum = typeof PetProfileModelSizeEnum[keyof typeof PetProfileModelSizeEnum];

/**
 * @export
 */
export const PetProfileModelFullGrownSizeEnum = {
    Unknown: 'UNKNOWN',
    Xs: 'XS',
    Sm: 'SM',
    M: 'M',
    L: 'L',
    Xl: 'XL',
    G: 'G'
} as const;
export type PetProfileModelFullGrownSizeEnum = typeof PetProfileModelFullGrownSizeEnum[keyof typeof PetProfileModelFullGrownSizeEnum];

/**
 * @export
 */
export const PetProfileModelWeightTypeEnum = {
    Unknown: 'UNKNOWN',
    Underweight: 'UNDERWEIGHT',
    Healthy: 'HEALTHY',
    Overweight: 'OVERWEIGHT'
} as const;
export type PetProfileModelWeightTypeEnum = typeof PetProfileModelWeightTypeEnum[keyof typeof PetProfileModelWeightTypeEnum];

/**
 * @export
 */
export const PetProfileModelSourceEnum = {
    Unknown: 'UNKNOWN',
    AdoptAPet: 'ADOPT_A_PET',
    ShelterLuv: 'SHELTER_LUV',
    RescueGroup: 'RESCUE_GROUP'
} as const;
export type PetProfileModelSourceEnum = typeof PetProfileModelSourceEnum[keyof typeof PetProfileModelSourceEnum];

/**
 * @export
 */
export const PetProfileModelStatusEnum = {
    Unknown: 'UNKNOWN',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Deleted: 'DELETED'
} as const;
export type PetProfileModelStatusEnum = typeof PetProfileModelStatusEnum[keyof typeof PetProfileModelStatusEnum];

/**
 * @export
 */
export const PetProfileModelStatusReasonEnum = {
    Unknown: 'UNKNOWN',
    Deceased: 'DECEASED',
    SwitchedRetailers: 'SWITCHED_RETAILERS',
    Other: 'OTHER'
} as const;
export type PetProfileModelStatusReasonEnum = typeof PetProfileModelStatusReasonEnum[keyof typeof PetProfileModelStatusReasonEnum];


/**
 * Check if a given object implements the PetProfileModel interface.
 */
export function instanceOfPetProfileModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function PetProfileModelFromJSON(json: any): PetProfileModel {
    return PetProfileModelFromJSONTyped(json, false);
}

export function PetProfileModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetProfileModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'submitter': !exists(json, 'submitter') ? undefined : SubmitterModelFromJSON(json['submitter']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'name': json['name'],
        'ownerName': !exists(json, 'ownerName') ? undefined : json['ownerName'],
        'type': PetTypeModelFromJSON(json['type']),
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'derived': !exists(json, 'derived') ? undefined : PetDerivedModelFromJSON(json['derived']),
        'sterilization': !exists(json, 'sterilization') ? undefined : json['sterilization'],
        'assistanceAnimal': !exists(json, 'assistanceAnimal') ? undefined : json['assistanceAnimal'],
        'age': !exists(json, 'age') ? undefined : json['age'],
        'birthdayEstimated': !exists(json, 'birthdayEstimated') ? undefined : json['birthdayEstimated'],
        'birthday': !exists(json, 'birthday') ? undefined : json['birthday'],
        'lifestage': !exists(json, 'lifestage') ? undefined : json['lifestage'],
        'adopted': !exists(json, 'adopted') ? undefined : json['adopted'],
        'markAdoptionForDeletion': !exists(json, 'markAdoptionForDeletion') ? undefined : json['markAdoptionForDeletion'],
        'adoptionDate': !exists(json, 'adoptionDate') ? undefined : json['adoptionDate'],
        'avatarModelId': !exists(json, 'avatarModelId') ? undefined : json['avatarModelId'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'fullGrownSize': !exists(json, 'fullGrownSize') ? undefined : json['fullGrownSize'],
        'weightType': !exists(json, 'weightType') ? undefined : json['weightType'],
        'weight': !exists(json, 'weight') ? undefined : json['weight'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusReason': !exists(json, 'statusReason') ? undefined : json['statusReason'],
        'breeds': !exists(json, 'breeds') ? undefined : ((json['breeds'] as Array<any>).map(PetBreedReferenceModelFromJSON)),
        'ridingStyles': !exists(json, 'ridingStyles') ? undefined : ((json['ridingStyles'] as Array<any>).map(PetRidingStyleModelFromJSON)),
        'primaryDisciplines': !exists(json, 'primaryDisciplines') ? undefined : ((json['primaryDisciplines'] as Array<any>).map(PetPrimaryDisciplineModelFromJSON)),
        'allergies': !exists(json, 'allergies') ? undefined : ((json['allergies'] as Array<any>).map(PetAllergyModelFromJSON)),
        'medications': !exists(json, 'medications') ? undefined : ((json['medications'] as Array<any>).map(PetMedicationModelFromJSON)),
        'medicationAllergies': !exists(json, 'medicationAllergies') ? undefined : ((json['medicationAllergies'] as Array<any>).map(PetMedicationAllergyModelFromJSON)),
        'medicalConditions': !exists(json, 'medicalConditions') ? undefined : ((json['medicalConditions'] as Array<any>).map(PetMedicalConditionModelFromJSON)),
        'bannerImageUri': !exists(json, 'bannerImageUri') ? undefined : json['bannerImageUri'],
        'markBannerImageForDeletion': !exists(json, 'markBannerImageForDeletion') ? undefined : json['markBannerImageForDeletion'],
        'avatar': !exists(json, 'avatar') ? undefined : PetProfileAvatarModelFromJSON(json['avatar']),
    };
}

export function PetProfileModelToJSON(value?: PetProfileModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'submitter': SubmitterModelToJSON(value.submitter),
        'userId': value.userId,
        'name': value.name,
        'ownerName': value.ownerName,
        'type': PetTypeModelToJSON(value.type),
        'gender': value.gender,
        'derived': PetDerivedModelToJSON(value.derived),
        'sterilization': value.sterilization,
        'assistanceAnimal': value.assistanceAnimal,
        'age': value.age,
        'birthday': value.birthday,
        'markAdoptionForDeletion': value.markAdoptionForDeletion,
        'adoptionDate': value.adoptionDate,
        'avatarModelId': value.avatarModelId,
        'size': value.size,
        'fullGrownSize': value.fullGrownSize,
        'weightType': value.weightType,
        'weight': value.weight,
        'source': value.source,
        'status': value.status,
        'statusReason': value.statusReason,
        'breeds': value.breeds === undefined ? undefined : ((value.breeds as Array<any>).map(PetBreedReferenceModelToJSON)),
        'ridingStyles': value.ridingStyles === undefined ? undefined : ((value.ridingStyles as Array<any>).map(PetRidingStyleModelToJSON)),
        'primaryDisciplines': value.primaryDisciplines === undefined ? undefined : ((value.primaryDisciplines as Array<any>).map(PetPrimaryDisciplineModelToJSON)),
        'allergies': value.allergies === undefined ? undefined : ((value.allergies as Array<any>).map(PetAllergyModelToJSON)),
        'medications': value.medications === undefined ? undefined : ((value.medications as Array<any>).map(PetMedicationModelToJSON)),
        'medicationAllergies': value.medicationAllergies === undefined ? undefined : ((value.medicationAllergies as Array<any>).map(PetMedicationAllergyModelToJSON)),
        'medicalConditions': value.medicalConditions === undefined ? undefined : ((value.medicalConditions as Array<any>).map(PetMedicalConditionModelToJSON)),
        'bannerImageUri': value.bannerImageUri,
        'markBannerImageForDeletion': value.markBannerImageForDeletion,
        'avatar': PetProfileAvatarModelToJSON(value.avatar),
    };
}

